<ion-button #button expand="black" class="scheduled-pickup-timepicker"
            [disabled]="hidePickupTime"
            [class.scheduled-pickup-timepicker--opened]="isDateTimeModalOpen"
            [class.scheduled-pickup-timepicker--filled]="dateTime" (click)="pickUpDateTime()">
  <div class="scheduled-pickup-timepicker__container">

              <ng-container *ngIf="dateTime else noDateTime">
                <span class="scheduled-pickup-timepicker__date-text">{{formatDateTime(dateTime)}}</span>
              </ng-container>
              <ng-template #noDateTime>{{noDateTimeSelectedText}}</ng-template>

    <ion-icon [name]="isDateTimeModalOpen ? 'arrow-dropup' : 'arrow-dropdown'" class="ion-float-right"></ion-icon>
  </div>
</ion-button>
<p class="err-msg" *ngIf="!valid && touched">
  {{errorMessageText}}
</p>
